export const SHEET_NAME = 'Project Milestone Report';

export const DEFAULT_COLUMN_MAPPING = {
  project_name: 'B',
  milestone_type: 'D',
  milestone_name: 'E',
  created_date: 'F',
  client: 'G',
  ready_for_design_tat_hours: 'K',
  design_tat_hours: 'L',
  pe_tat_hours: 'M',
  ready_for_pe_tat_hours: 'N',
  total_tat_hours: 'O',
  ready_for_ee_tat_hours: 'P',
  ee_tat_hours: 'Q',
  ready_wet_stamps_tat_hours: 'R',
  in_house_vs_external: 'S',
  project_address: 'T',
  project_start_date: 'V',
  project_end_date: 'W',
  service_type: 'X',
  partner_engineer: 'Y',
  partner_drafter: 'Z',
  pe_engineer: 'AA',
  pe_reviewer: 'AB',
  design_reviewer: 'AC', // Auto-prefers Milestone Design Reviewer when that header exists
  milestone_design_reviewer: 'AV',
  ee_reviewer: 'AD',
  senior_designer: 'AE',
  electrical_engineer_of_record: 'AF',
  structural_engineer_of_record: 'AG',
  design_engineer: 'AH',
  structure_type: 'AI',
  milestone_start_date: 'AJ',
  milestone_end_date: 'AK',
  customer_restamp_reason: 'AL',
  cre_restamp_reason: 'AM',
  on_hold_reason: 'AN',
  on_hold_other_reason: 'AO',
  on_hold_time_hours: 'AP',
  state: 'AQ',
  permit_applicant: 'AR',
  ee_engineer: 'AS',
  milestone_ee_engineer: 'AW',
  milestone_pe_engineer: 'AX',
  milestone_qa_result: 'AU',
  design_review_in_progress_tat_hours: 'AY',
  design_in_progress_tat_hours: 'AZ',
  pe_in_progress_tat_hours: 'BA',
  ee_in_progress_tat_hours: 'BB',
  dashboard_date: 'AK',
};

export const COLUMN_LABELS = {
  project_name: 'Project Name',
  milestone_type: 'Milestone Type',
  milestone_name: 'Project Milestone Name',
  created_date: 'Created Date',
  client: 'Client',
  ready_for_design_tat_hours: 'Ready for Design TAT Hours',
  design_tat_hours: 'Design TAT Hours',
  pe_tat_hours: 'PE TAT Hours',
  ready_for_pe_tat_hours: 'Ready for PE TAT Hours',
  total_tat_hours: 'Total TAT Hours',
  ready_for_ee_tat_hours: 'Ready for EE TAT Hours',
  ee_tat_hours: 'EE TAT Hours',
  ready_wet_stamps_tat_hours: 'Ready for Wet Stamps TAT Hours',
  in_house_vs_external: 'In House vs External',
  project_address: 'Project Address',
  project_start_date: 'Project Start Date',
  project_end_date: 'Project End Date',
  service_type: 'Service Type',
  partner_engineer: 'Partner Engineer',
  pe_engineer: 'Milestone Structural Engineer',
  design_reviewer: 'Design Reviewer',
  milestone_design_reviewer: 'Milestone Design Reviewer',
  ee_reviewer: 'EE Reviewer',
  senior_designer: 'Senior Designer',
  design_engineer: 'Design Engineer',
  structure_type: 'Structure Type',
  milestone_start_date: 'Milestone Start Date',
  milestone_end_date: 'Milestone End Date',
  customer_restamp_reason: 'Customer Restamp Reason',
  cre_restamp_reason: 'CRE Restamp Reason',
  on_hold_reason: 'On-Hold Reason',
  on_hold_other_reason: 'On-Hold Other Reason',
  on_hold_time_hours: 'On Hold Time Hours',
  state: 'State',
  permit_applicant: 'Permit Applicant',
  ee_engineer: 'Milestone Electrical Engineer',
  milestone_ee_engineer: 'Milestone EE Engineer',
  milestone_pe_engineer: 'Milestone PE Engineer',
  milestone_qa_result: 'Milestone QA Result',
  design_review_in_progress_tat_hours: 'Design Review In Progress TAT Live',
  design_in_progress_tat_hours: 'Design In Progress Turn Around Time Live',
  pe_in_progress_tat_hours: 'PE In Progress Turn Around Time Live',
  ee_in_progress_tat_hours: 'EE In Progress Turn Around Time Live',
  dashboard_date: 'Dashboard Date Column',
};


export const HEADER_ALIASES = {
  project_name: ['Project: Project Name', 'Project Name'],
  milestone_type: ['Milestone Type'],
  milestone_name: ['Project Milestone: Project Milestone Name', 'Project Milestone Name'],
  created_date: ['Project Milestone: Created Date', 'Created Date'],
  client: ['Account', 'Client'],
  service_type: ['Service_Type', 'Service Type'],
  partner_engineer: ['Partner Engineer'],
  pe_engineer: ['Milestone Structural Engineer'],
  design_reviewer: ['Milestone Design Reviewer', 'Design Reviewer'],
  milestone_design_reviewer: ['Milestone Design Reviewer'],
  ee_reviewer: ['EE Reviewer'],
  senior_designer: ['Senior Designer'],
  design_engineer: ['Milestone Design Engineer', 'Design Engineer'],
  state: ['State'],
  permit_applicant: ['Permit Applicant'],
  ee_engineer: ['Milestone Electrical Engineer'],
  milestone_ee_engineer: ['Milestone EE Engineer', 'Milestone Electrical Engineer'],
  milestone_pe_engineer: ['Milestone PE Engineer', 'Milestone Structural Engineer'],
  milestone_qa_result: ['Milestone QA Result'],
  design_review_in_progress_tat_hours: ['Design Review In Progress TAT Live', 'Design Review In Progress TAT'],
  design_in_progress_tat_hours: ['Design In Progress Turn Around Time Live', 'Design In Progress TAT Live', 'Design In Progress Turnaround Time Live'],
  pe_in_progress_tat_hours: ['PE In Progress Turn Around Time Live', 'PE In Progress TAT Live', 'PE In Progress Turnaround Time Live'],
  ee_in_progress_tat_hours: ['EE In Progress Turn Around Time Live', 'EE In Progress TAT Live', 'EE In Progress Turnaround Time Live'],
  milestone_start_date: ['Milestone Start Date'],
  milestone_end_date: ['Milestone End Date'],
  customer_restamp_reason: ['Milestone Customer Restamp Reason', 'Customer Restamp Reason'],
  cre_restamp_reason: ['Milestone CRE Restamp Reason', 'CRE Restamp Reason'],
  on_hold_reason: ['On-Hold Reason', 'On Hold Reason'],
  on_hold_other_reason: ['On-Hold Other Reason', 'On Hold Other Reason'],
  on_hold_time_hours: ['On Hold Time Live', 'On Hold Time Hours'],
};

export const REQUIRED_MAPPING_KEYS = [
  'project_name',
  'milestone_type',
  'client',
  'service_type',
  'partner_engineer',
  'pe_engineer',
  'design_reviewer',
  'ee_reviewer',
  'senior_designer',
  'design_engineer',
  'state',
  'permit_applicant',
  'ee_engineer',
  'dashboard_date',
];

export const ROLE_DEFINITIONS = [
  { key: 'design_engineer', label: 'Design Engineer', normField: 'design_engineer_norm', rawField: 'design_engineer_raw' },
  { key: 'pe_engineer', label: 'PE Engineer', normField: 'pe_engineer_norm', rawField: 'pe_engineer_raw' },
  { key: 'ee_engineer', label: 'EE Engineer', normField: 'ee_engineer_norm', rawField: 'ee_engineer_raw' },
  { key: 'permit_applicant', label: 'Permit Applicant', normField: 'permit_applicant_norm', rawField: 'permit_applicant_raw' },
  { key: 'senior_designer', label: 'Senior Designer', normField: 'senior_designer_norm', rawField: 'senior_designer_raw' },
  { key: 'design_reviewer', label: 'Design Reviewer', normField: 'design_reviewer_norm', rawField: 'design_reviewer_raw' },
  { key: 'ee_reviewer', label: 'EE Reviewer', normField: 'ee_reviewer_norm', rawField: 'ee_reviewer_raw' },
  { key: 'partner_engineer', label: 'Partner Engineer', normField: 'partner_engineer_norm', rawField: 'partner_engineer_raw' },
];

export const PRESET_LABELS = [
  'Today',
  'Previous Day',
  'This Week',
  'Previous Week',
  'This Month',
  'Previous Month',
  'This Year',
  'Previous Year',
];

export const MILESTONE_COLUMNS = [
  { key: 'initial_project_delivery', label: 'Initial Project Delivery', milestoneType: 'Initial Project Delivery' },
  { key: 'restamp_required', label: 'Restamp Required', milestoneType: 'Restamp Required' },
  { key: 'post_install_letter', label: 'Post Install Letter', milestoneType: 'Post Install Letter' },
  { key: 'other', label: 'Other', milestoneType: 'Other' },
];

export const DEFAULT_TAT_SETTINGS = {
  defaultTatHours: 24,
  uploadRetentionCount: 2,
  serviceTatHours: {
    Design: 24,
    EE: 24,
    PE: 24,
    'Design & PE': 48,
    'EE & PE': 48,
    'Design & EE': 24,
    'Design & EE & PE': 24,
    'Design & Permit': 24,
    'Design & LabelsAndPlacards & Permit': 24,
    'Design & LabelsAndPlacards': 24,
    All: 24,
  },
};

export const TAT_SERVICE_OPTIONS = Object.keys(DEFAULT_TAT_SETTINGS.serviceTatHours);
